import RouteItem from ".";
import ChapterBookPublished from "../pages/research/ChapterBookPublished";
import ConferencePaperPresentation from "../pages/research/ConferencePaperPresentation";
import Copyrights from "../pages/research/Copyrights";
import InnovationsRegisteredPatents from "../pages/research/InnovationsRegisteredPatents";
import OngoingResearchProjects from "../pages/research/OngoingResearchProjects";
import ResearchPaperPublication from "../pages/research/ResearchPaperPublication";

// Research SubMenu Pages
export const researchRoutes: RouteItem = {
  key: "router-research",
  title: "Research",
  tooltip: "Research",
  path: "/research",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-research-ongoing-reserch-project",
      title: "Ongoing Research Projects",
      tooltip: "Ongoing Research Projects",
      path: "ongoing-research-projects",
      enabled: true,
      component: OngoingResearchProjects,
      appendDivider: true,
    },
    {
      key: "router-research-research-paper-publication",
      title: "Research Paper Publication",
      tooltip: "Research Paper Publication",
      path: "research-paper-publication",
      enabled: true,
      component: ResearchPaperPublication,
      appendDivider: true,
    },
    {
      key: "router-research-chapter/books-published",
      title: "Chapters/Books published",
      tooltip: "Chapters/Books published",
      path: "chapter-book-published",
      enabled: true,
      component: ChapterBookPublished,
      appendDivider: true,
    },
    {
      key: "router-research-conference-paper-presentation",
      title: "Conference Paper Presentation",
      tooltip: "Conference Paper Presentation",
      path: "conference-paper-presentation",
      enabled: true,
      component: ConferencePaperPresentation,
      appendDivider: true,
    },
    {
      key: "router-research-innovation-&-registered-patents",
      title: "Innovations & Registered Patents",
      tooltip: "Innovations & Registered Patents",
      path: "innovation-&-registered-patents",
      enabled: true,
      component: InnovationsRegisteredPatents,
      appendDivider: true,
    },
    {
      key: "router-research-copyrights",
      title: "Copyrights",
      tooltip: "Copyrights",
      path: "copyrights",
      enabled: true,
      component: Copyrights,
      appendDivider: true,
    },
  ],
};
